import { AnalysisAPI } from "@/api";
import { CreateTraceIndicatorModal } from "@/components/Modals";
import { usePermissions } from "@/hooks/usePermissions";
import { Button, styled } from "@monolith-forensics/monolith-ui";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { TraceIndicatorItem } from "./TraceIndicatorItem";
import { TraceIndicator } from "@/Features/TraceIndicators";
import { TimelineEvent } from "../../TimelineEvents.types";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 0px;
`;

const TraceIndicatorsList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 0px;

  padding-right: 8px;
  gap: 15px;

  overflow-y: auto;
`;

export const FlyoutTraceIndicatorsTab: React.FC<{
  defaultEventData: TimelineEvent;
}> = ({ defaultEventData }) => {
  const { currentUser } = usePermissions();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const { data, refetch } = useQuery({
    queryKey: [
      "timeline-events",
      "trace-indicators",
      "list",
      { uuid: defaultEventData.uuid, include_attributes: true },
    ],
    queryFn: ({ queryKey }) => {
      const [_, __, ___, query] = queryKey;
      return AnalysisAPI.TimelineEvents.getTraceIndicators(query);
    },
    enabled: !!defaultEventData.uuid,
  });

  const onCreateTraceIndicator = () => {
    refetch();
    setShowCreateModal(false);
  };

  const traceIndicators = data?.data || [];

  return (
    <StyledContainer>
      <div
        style={{
          display: "flex",
          flex: "initial",
          flexDirection: "row",
          gap: 5,
          alignContent: "center",
          alignItems: "center",
          marginBottom: 10,
          marginTop: 10,
          width: "100%",
        }}
      >
        <Button
          size="xxs"
          variant="contained"
          color="primary"
          onClick={() => setShowCreateModal(true)}
        >
          + New Indicator
        </Button>
        <CreateTraceIndicatorModal
          show={showCreateModal}
          defaultFormData={{
            created_by_id: currentUser.user_id,
            case_uuid: defaultEventData?.case?.uuid,
            timeline_event_uuid: defaultEventData?.uuid,
            evidence_uuid: defaultEventData?.source_evidence?.uuid,
          }}
          onClose={() => setShowCreateModal(false)}
          onCancel={() => setShowCreateModal(false)}
          onSubmit={onCreateTraceIndicator}
        />
      </div>
      <TraceIndicatorsList>
        {traceIndicators.map((ti: TraceIndicator) => {
          return <TraceIndicatorItem key={ti.uuid} data={ti} />;
        })}
      </TraceIndicatorsList>
    </StyledContainer>
  );
};
